import { useState } from 'react';

import { useUnsavedChangesPrompt } from '@/shared/hook';
import { FctDialog } from '@/shared/ui';

import { PatientContactConfirmationSection } from './patient-contact-confirmation-section';
import { PatientContactOutcomeSection } from './patient-contact-outcome-section';

export type PatientContactDialogProps = {
  closeDialog: (open: boolean) => void;
  open: boolean;
};

export function PatientContactDialog({ closeDialog, open }: PatientContactDialogProps) {
  const [reason, setReason] = useState<null | string>(null);
  const [confirmationSection, setConfirmationSection] = useState<boolean>(true);

  useUnsavedChangesPrompt(!confirmationSection);

  const handleCloseDialog = () => {
    setReason(null);
    setConfirmationSection(true);
    closeDialog(true);
  };

  return (
    <FctDialog
      onOpenChange={confirmationSection ? handleCloseDialog : () => closeDialog(false)}
      open={open}
      title={
        confirmationSection
          ? 'FCT.REPORTING.HEADER.CONTACT_DETAILS.CONFIRMATION_TITLE'
          : 'FCT.REPORTING.HEADER.CONTACT_DETAILS.INFO_TITLE'
      }
    >
      <div className="w-full">
        {confirmationSection ? (
          <PatientContactConfirmationSection
            onCancel={handleCloseDialog}
            onNext={() => setConfirmationSection(false)}
            reason={reason}
            setReason={setReason}
          />
        ) : (
          <PatientContactOutcomeSection closeDialog={handleCloseDialog} reason={reason!} />
        )}
      </div>
    </FctDialog>
  );
}
